export const MIJN_CONVERSATIONAL_OPERATIONAL = 'mijn-klant-conversational.operational';
export const CHAT_SESSION_ID = 'chatSessionId';
